import { FarmType } from '@/common/Enum/FarmType.Enum';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '@services/user.service';
import { TableModule } from 'primeng/table';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent implements OnInit {
  public users: any = [];
  totalRecords: number = 0;
  pageSize: number = 20;
  currentPage: number = 1;
  public farmType = FarmType;
  filterForm: FormGroup;
  constructor(private userService: UserService,
    private formBuilder: FormBuilder
  ) {

  }

  ngOnInit(): void {
    this.filterForm = this.formBuilder.group({
      nameFilter: [''],
      emailFilter: [''],
      phoneFilter: ['']
    });
    this.getUser();

  }
  getUser() {
    const { nameFilter, emailFilter, phoneFilter } = this.filterForm.value;
    //console.log(this.emailFilter);
    this.userService.getUserList(nameFilter, phoneFilter,emailFilter, this.currentPage, this.pageSize).subscribe(
      result => {
        console.log(result.totalRecords);
        this.users = result.users;
        this.totalRecords = result.totalRecords;


      }
    );
  }
  getFarmType(value: number): string {
    return FarmType[value];
  }
  onPageChange(event: any) {
    this.currentPage = event.page + 1; // PrimeNG paginator starts from 0
    this.getUser();
  }

  applyFilters() {
    console.log("filter");
    this.currentPage = 1; // Reset page number when filters are applied
    this.getUser();
  }
}
